import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpRequest } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { LogCreateDTO } from '../dtos/log.dto';

@Injectable({
  providedIn: 'root'
})
export class LoggingService {

  constructor(private _httpClient: HttpClient) { }

  getLogs(logTypeId: any) {
    let href = environment.AUTH_API_URL + 'logging/LoggingFindByLogTypeIdDTO';

    let data = {
      logTypeId: logTypeId
    }

    return this._httpClient.post<any>(href, data, {
      headers: {
        // accept: '*/*',
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' + (localStorage.getItem('userAccessToken') || ''),
      },
    });
  }

  createLog(logObject: LogCreateDTO) {
    let href = environment.AUTH_API_URL + 'logging';

    return this._httpClient.post<any>(href, logObject, {
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' + (localStorage.getItem('userAccessToken') || ''),
      },
    });
  }

  createCallLog(logObject: LogCreateDTO) {
    let href = environment.AUTH_API_URL + 'logging';

    return this._httpClient.post<any>(href, logObject, {
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' + (localStorage.getItem('userAccessToken') || ''),
      },
    });
  }
}
